var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call } from "redux-saga/effects";
import { EDocumentMemberTypes } from "../../types/document.types";
import * as documentApi from "../documents/document.api";
import { getDocumentCategoryId } from "../rentRegistration/rentRegistration.utils";
export function uploadNewDocument(params) {
    var createRegistration, registration, documentType, file, registrationData, presignedUrl, metaData, document, accountIds, membersToAdd;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                createRegistration = params.createRegistration, registration = params.registration, documentType = params.documentType, file = params.file;
                registrationData = createRegistration || registration;
                if (!registrationData) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(documentApi.uploadDocumentToS3, file)];
            case 1:
                presignedUrl = _a.sent();
                metaData = {
                    categoryId: getDocumentCategoryId({ documentType: documentType }),
                    filename: file.name,
                    propertyId: registrationData.propertyId,
                    contractId: registrationData.contractId,
                };
                return [4 /*yield*/, call(documentApi.uploadDocument, presignedUrl, metaData)];
            case 2:
                document = _a.sent();
                accountIds = [];
                if (createRegistration) {
                    accountIds = createRegistration.members.map(function (m) { return m.accountId; });
                }
                else if (registration) {
                    accountIds = registration.members.map(function (m) { return m.account.id; });
                }
                membersToAdd = accountIds.map(function (accountId) { return ({
                    roles: [EDocumentMemberTypes.Viewer],
                    accountId: accountId,
                }); });
                return [4 /*yield*/, call(documentApi.addMembers, {
                        id: document.id,
                        members: membersToAdd,
                    })];
            case 3:
                _a.sent();
                return [2 /*return*/, document.id];
        }
    });
}
export function mapDocument(params) {
    var registrationDocument, createRegistration, registration, result, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                registrationDocument = params.registrationDocument, createRegistration = params.createRegistration, registration = params.registration;
                result = __assign({}, registrationDocument);
                if (!(registrationDocument.documentId &&
                    typeof registrationDocument.documentId !== "string")) return [3 /*break*/, 2];
                _a = result;
                return [4 /*yield*/, call(uploadNewDocument, {
                        createRegistration: createRegistration,
                        registration: registration,
                        documentType: registrationDocument.documentType,
                        file: registrationDocument.documentId,
                    })];
            case 1:
                _a.documentId = _b.sent();
                _b.label = 2;
            case 2: return [2 /*return*/, result];
        }
    });
}
